import { useMemo, useRef } from "react";
import useSnakeGame from "./useSnakeGame";

export type SnakeGameProps = {
  autoShow?: boolean;
  startTickVelocity?: number;
};

const SnakeGame: React.FC<SnakeGameProps> = props => {
  const gameRef = useRef<HTMLDivElement>(null);
  const game = useSnakeGame(gameRef, props);
  const blockSize = useMemo(() => {
    let finalSize = 0;
    if (game.showGame) finalSize = game.blockSize - (game.tinyBlocks ? 4 : 0);
    return finalSize;
  }, [game.tinyBlocks, game.blockSize, game.showGame]);

  return (
    <div
      ref={gameRef}
      className='devprofile-extra-gTable'
      style={{
        width: game.showGame ? game.areaSize[0] * game.blockSize : 0,
        height: game.showGame ? game.areaSize[1] * game.blockSize : 0,
        borderWidth: game.showGame ? game.blockSize : 0
      }}>
      {game.snakeBlocks.map((bInfo, index) => {
        return (
          <div
            key={"pb" + index}
            className='extra-gTable-block'
            style={{
              width: blockSize,
              height: blockSize,
              left: bInfo[0] * game.blockSize + (game.tinyBlocks ? 2 : 0),
              top: bInfo[1] * game.blockSize + (game.tinyBlocks ? 2 : 0),
              backgroundColor:
                index === game.snakeBlocks.length - 1 ? "white" : "lightgrey"
            }}></div>
        );
      })}
      <div
        id='apple'
        key={"a"}
        className='extra-gTable-block'
        style={{
          width: blockSize,
          height: blockSize,
          left: game.applePos.x * game.blockSize + (game.tinyBlocks ? 2 : 0),
          top: game.applePos.y * game.blockSize + (game.tinyBlocks ? 2 : 0),
          backgroundColor: "red"
        }}></div>
      <div
        className='extra-gTable-text'
        style={{
          fontSize: game.blockSize,
          top: -game.blockSize
        }}>
        <p>{game.infoText}</p>
      </div>

      {game.showInfo && (
        <div
          style={{
            fontSize: game.blockSize,
            backgroundColor: "darkblue",
            padding: 16,
            margin: 16
          }}>
          <p>R: Iniciar/Reiniciar Juego</p>
          <p>W-A-S-D o Flechitas: Mover</p>
          <p>O-P: Cambiar tamaño</p>
          <p>X: Cambiar estilo</p>
        </div>
      )}
      {game.showGame && (
        <p
          style={{
            position: "absolute",
            fontSize: game.blockSize,
            bottom: 0
          }}>
          H para ver controles{" "}
        </p>
      )}
    </div>
  );
};

export default SnakeGame;
